import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { LinkedinSettings } from 'crono-fe-common/types/linkedinSettings';

export default function useGetLinkedinSettings() {
  const request: Request = {
    url: `${ENDPOINTS.linkedinSettings.main}`,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.linkedinSettings.main],
    queryFn: () => client(request),
    staleTime: 60 * 30 * 1000,
  };

  const { data, ...rest } = useQuery<Response<LinkedinSettings>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}
